import type { HTMLAttributes, ReactNode } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  selected?: boolean;
  glass?: boolean;
  children: ReactNode;
}

export function Card({
  interactive = false,
  selected = false,
  glass = false,
  className = "",
  children,
  ...rest
}: CardProps) {
  return (
    <div
      {...rest}
      className={[
        "rounded-[var(--radius-control-lg)] p-5",
        glass ? "liquid-glass" : "bg-surface-raised border shadow-[var(--shadow-md)]",
        "transition-all duration-[var(--duration-base)]",
        selected
          ? "border-accent bg-[var(--accent-soft)]"
          : glass
            ? ""
            : "border-border-subtle",
        interactive
          ? glass
            ? "liquid-glass-interactive cursor-pointer"
            : "cursor-pointer hover:border-border-strong hover:shadow-[var(--shadow-lg)]"
          : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
}

/** Skeleton com a forma exata do conteúdo final — CLS < 0,1 (RNF-03). */
export function Skeleton({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`animate-pulse rounded-[var(--radius-control-sm)] bg-[var(--border-subtle)] ${className}`}
    />
  );
}

/**
 * Estado vazio. Nunca uma tela em branco.
 * Sem ilustração cartunesca, sem emoji, sem "Ops!" — docs/01 §3.2.
 */
export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <h2 className="type-h2 text-text-cream">{title}</h2>
      {description !== undefined && (
        <p className="type-body mt-3 max-w-sm text-text-secondary">{description}</p>
      )}
      {action !== undefined && <div className="mt-8">{action}</div>}
    </div>
  );
}
